
import React from "react";

const Impactgrid = () => {
  return (
    <section className="pb-1 px-4 md:px-10 pt-4">
      <div className="container mx-auto">
        <h2 className="text-2xl md:text-2xl lg:text-4xl notoh font-bold text-center mb-8 sm:mb-12 text-gray-800  mt-8 lg:mt-5 ">
          Our Impact
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {/* First Card */}
          <div className="bg-gray-50 shadow-md rounded-xl p-6 sm:p-8 text-center flex flex-col items-center justify-center h-[290px]">
            <p className="text-4xl sm:text-5xl md:text-6xl font-bold text-blue-600 mb-4">180+</p>
            <p className="text-md sm:text-lg text-gray-700">
              Trusted by 180+ Schools Across India for Seamless
              {" "}
              <span className="font-semibold text-black">Educational Tours Worldwide!</span>
            </p>
          </div>

          {/* First Image */}
          <div className="overflow-hidden">
            <img
              src="https://imgs.search.brave.com/P4U_lOO1wtNyIxq2YoHk1kMk969rhLteaju00a-xCqQ/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5nZXR0eWltYWdl/cy5jb20vaWQvMTQ1/NTAxMjM5MC9waG90/by9wb3J0cmFpdC1v/Zi15b3VuZy1zdHVk/ZW50cy1hdC11bml2/ZXJzaXR5LmpwZz9z/PTYxMng2MTImdz0w/Jms9MjAmYz0walN2/OTNqajJOMnczbWVD/OXUyYTJFMThNbDcy/eU11WHIwQjBockZW/SHVNPQ"
              alt="Immerse student graduation day"
              className="object-cover w-full rounded-xl bg-gray-100 aspect-video h-[290px]"
            />
          </div>

          {/* Second Card */}
          <div className="bg-gray-50 shadow-md rounded-xl p-6 sm:p-8 text-center flex flex-col items-center justify-center h-[290px]">
            <p className="text-4xl sm:text-5xl md:text-6xl font-bold text-blue-600 mb-4">3800</p>
            <p className="text-md sm:text-lg text-gray-700">
              Inspiring Minds, One Journey at a Time - Over 3,800 Indian Students
              {" "}
              <span className="font-semibold text-black">Empowered Through Global Educational Adventures</span>
            </p>
          </div>

          {/* Second Image */}
          <div className="overflow-hidden">
            <img
              src="https://imgs.search.brave.com/ps8hp5voP9Wv1vXv2ELeABmweycPEVe9_dC7OPkKsUc/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5nZXR0eWltYWdl/cy5jb20vaWQvODk2/NDU4MjIwL3Bob3Rv/L211bHRpLWV0aG5p/Yy1ncm91cC1vZi10/ZWVuYWdlcnMtYXQt/c2Nob29sLW91dGRv/b3JzLmpwZz9zPTYx/Mng2MTImdz0wJms9/MjAmYz14d1I4ZGJY/ekEyeXRtTkVPNHhH/TXRnXzY0RWc1bHJk/YWJjWW1pNnAzMU1B/PQ"
              alt="Balliol Graduation"
              className="object-cover w-full rounded-xl bg-gray-100 aspect-video h-[290px] "
            />
          </div>
          
          {/* Third Image */}
          <div className="overflow-hidden ">
            <img
              src="https://imgs.search.brave.com/uMldVi_t48_tOqiDHXlK-wBVkQhwmTa9kfqDw-pdAc0/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvMTQz/MDcxMzkxL3Bob3Rv/L3N0dWRlbnRzLXNt/aWxpbmctdG9nZXRo/ZXIuanBnP3M9NjEy/eDYxMiZ3PTAmaz0y/MCZjPUM3SGtRdkFi/NWJZc1lPa0FFYXRJ/N0JBMXlZVWlYcE9k/TjhWMlNXM2x6eWc9"
              alt="Balliol Graduates"
              className="object-cover w-full rounded-xl bg-gray-100 aspect-video h-[290px] lg:block hidden"
            />
          </div>

          {/* Third Card */}
          <div className="bg-gray-50 shadow-md rounded-xl p-6 sm:p-8 text-center flex flex-col items-center justify-center h-[290px]">
            <p className="text-4xl sm:text-5xl md:text-6xl font-bold text-blue-600 mb-4">100%</p>
            <p className="text-md sm:text-lg text-gray-700">
              Delivering 100% Customer Satisfaction for Schools with Unmatched
              {" "}
              <span className="font-semibold text-black">Educational Tour
                Experiences within India and UAE!</span>
            </p>
          </div>

          {/* Fourth Image */}
          <div className="overflow-hidden">
            <img
              src="https://imgs.search.brave.com/fmBArJCVvBJ8gdPn-wz1E0FybWD2CK_c0Wgw4tbuhto/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5nZXR0eWltYWdl/cy5jb20vaWQvMTQx/MDk5OTQwOC9waG90/by9zdHVkZW50cy1v/bi1jYW1wdXMuanBn/P3M9NjEyeDYxMiZ3/PTAmaz0yMCZjPU0z/clVzQWhQWXZ3T0dh/NFZGNzhrUjVqZ0pv/SnpWNlc0X3cwOEEx/N3hheUE9"
              alt="Balliol College Architecture"
              className="object-cover w-full rounded-xl bg-gray-100 aspect-video h-[290px]"
            />
          </div>

          {/* Fourth Card */}
          <div className="bg-gray-50 shadow-md rounded-xl p-6 sm:p-8 text-center flex flex-col items-center justify-center h-[290px]">
            <p className="text-4xl sm:text-5xl md:text-6xl font-bold text-blue-600 mb-4">400</p>
            <p className="text-md sm:text-lg text-gray-700">
              Over 100 Students every year have Trusted Us to
              {" "}
              <span className="font-semibold text-black">Shape Their</span>{" "}
              Overseas Education Journey!
            </p>
          </div>
          <div className="overflow-hidden ">
            <img
              src="https://imgs.search.brave.com/uMldVi_t48_tOqiDHXlK-wBVkQhwmTa9kfqDw-pdAc0/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvMTQz/MDcxMzkxL3Bob3Rv/L3N0dWRlbnRzLXNt/aWxpbmctdG9nZXRo/ZXIuanBnP3M9NjEy/eDYxMiZ3PTAmaz0y/MCZjPUM3SGtRdkFi/NWJZc1lPa0FFYXRJ/N0JBMXlZVWlYcE9k/TjhWMlNXM2x6eWc9"
              alt="Balliol Graduates"
              className="object-cover w-full rounded-xl bg-gray-100 aspect-video h-[290px] lg:hidden block"
            />
          </div>

        </div>

      </div>
    </section>
  );
};

export default Impactgrid;
